import useSWR from 'swr'
import { authCall } from '.'
import {
  CustomPaginationQuery,
  CreateGuest,
  IGetGuestResponse,
  GetResidentReq,
  ResidentResponse,
  PropertyResponse,
  AddGuestRes,
  GuestEntryType,
  GuestEntryResponse,
} from '../interfaces/security'
import { Guests, residents, getAllGuest } from './endpoints'

const SecurityService = {
  useGetGuestList: ({
    page = 1,
    limit = 10,
    search = '',  
    code = '', 
    status = '',  
  }: CustomPaginationQuery & { search?: string; code?: string; status?: string}) => {
    let url = `${getAllGuest}?page=${page}&limit=${limit}`



    if (search) {
      url += `&search=${encodeURIComponent(search)}`
    }

    if (code) {
      url += `&code=${encodeURIComponent(code)}`
    }
    if (status && status.toLowerCase() !== 'all') {
      url += `&status=${encodeURIComponent(status)}`
    }

    return useSWR(url, () => {
      return authCall<IGetGuestResponse>({
        url,
        method: 'get',
      })
    })
  },

  createGuest: (data: CreateGuest) => {
    const url = Guests
    return authCall<AddGuestRes>({
      url,
      data,
      method: 'post',
    })
  },

  confirmGuestEntry: (code: string, data: GuestEntryType) => {
    const url = `estates/guests/${code}/entry`
    return authCall<GuestEntryResponse>({
      url,
      data,
      method: 'patch',
    })
  },

  useGetResidents: ({ name, type = 'resident', all = true }: GetResidentReq) => {
    const url = `${residents}?name=${name}&type=${type}&all=${all}`
    return useSWR(url, () => {
      return authCall<ResidentResponse>({
        url,
        method: 'get',
      })
    })
  },

  useGetResidentProperties: (residentId: string | null) => {
    const url = residentId ? `${residents}/${residentId}/properties` : null

    return useSWR<PropertyResponse>(url, () => {
      return authCall<PropertyResponse>({
        url: url as string,
        method: 'get',
      })
    })
  },
}

export default SecurityService
